// Add your carousel items here, e.g., { image: '...', title: '...' }



const company = [
  {
    id: 1,
    img: require('../images/coa/bcpl.jpg'),
    name: "Banwari Aromas Pvt Ltd.",
    title: "Manufacturer & Exporter of Mint Oils, Aromatic Chemicals & Allied Products",
    address: "B-522 RIICO Industrial Area, Phase-I, Bhiwadi-301019, Distt. Alwar, Rajasthan ",
    phone: "+91 1493 220046",
    email: "bcpl.522@gmail.com",
    website: "www.banwarichemicals.com",
    CIN: "U24117RJ1995PTC010897",
    GST: "08AABCB7218F1ZW",
  },
  {
    id: 2,
    img: require('../images/coa/petrose.jpg'),
    name: "Petorose Alcones Private Limited",
    title: "",
    address: "B-522, RIICO Industrial Area, Phase I, Bhiwadi, Dist. Alwar, Rajasthan - 301 019 INDIA",
    phone: "+91 1493 220046 ",
    email: "contact@petorosealcones.com",
    website: "www.petorosealcones.com",
    CIN: "U24117RJ1995PTC010897",
    GST: "08AABCB7218F1ZW",
  },
  {
    id: 3,
    img: require('../images/coa/samde.png'),
    name: "Samde Aromatic Pvt Ltd",
    title: "Isolates ,Essential Oils ,Terpenes ,Organic Products",
    address: "E-46 (B) Industrial Area, P.O. Bhiwadi - 301 019, Distt. Alwar, Rajasthan, India",
    phone: "+91-1493-221725, +91-9314014408",
    email: "accounts@samde.in",
    website: "samde.in",
    CIN: "U24294RJ1995PTC010098",
    GST: "08AACCS4561M1ZZ",
  },
]

export default company;

